import { render, staticRenderFns } from "./AssessmentBriefing.vue?vue&type=template&id=37a68895&scoped=true"
import script from "./AssessmentBriefing.vue?vue&type=script&lang=js"
export * from "./AssessmentBriefing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a68895",
  null
  
)

export default component.exports